import { Component, Input } from '@angular/core';
import { BaseToolComponent } from '../../base-tool.component';
import { ApplicationService } from 'src/app/services/application.service';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TintableLayerData } from 'src/app/data/configurator/layer/tintable-layer.data';
import { WingdingsShapeLayerData } from 'src/app/data/configurator/layer/wingdings-shape-layer.data';
import { FontsLibrairie } from 'src/app/data/fonts.librairie';
import { SquareShapeLayerData } from 'src/app/data/configurator/layer/square-shape-layer.data';
import { CircleShapeLayerData } from 'src/app/data/configurator/layer/circle-shape-layer.data';
import { TriangleShapeLayerData } from 'src/app/data/configurator/layer/triangle-shape-layer.data';
import { ContextData } from 'src/app/data/context.data';
import { LineShapeLayerData } from 'src/app/data/configurator/layer/line-shape-layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';

@Component({
  selector: 'shape-panel',
  templateUrl: './shape-panel.component.html',
  host: {
    class: 'shape-panel'
  }
})
export class ShapePanelComponent extends BaseToolComponent {

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }

  public symbols:Array<any> = [];


  private _currentSize:number = 1;
  public set currentSize(value: number) {
    if (this.layerData && this.layerData.type == LayerData.LINE_SHAPE) {
      if (!this._savedData) {
        this._savedData = { y: this.layerData.y, height: this.layerData.height};
      }

      this.layerData.y += (this.layerData.height - this.currentSize * ContextData.MM_TO_PIXELS) / 2;
      this.layerData.height = this.currentSize * ContextData.MM_TO_PIXELS;

      this.layerData.invalidate();

      if (this._historyTimeout) {
        clearTimeout(this._historyTimeout);
      }
      this._historyTimeout = setTimeout(() => {
        HistoryData.add(this._labelData, this._layerData, CommandData.SET_LINE_HEIGHT, { y: this._savedData.y, height: this._savedData.height});
        this._savedData = null;
      }, 500);
    }

    this._currentSize = value;
  }
  public get currentSize(): number {
    return this._currentSize;
  }

  private _historyTimeout: any;
  private _savedData: any;

  /**
	 * Constructor
	 */
  constructor(
    private applicationService: ApplicationService
  ) {
    super();
  }

	/**
	 * On init
	 */
  ngOnInit() {
    // FontsLibrairie.loadFont('Material Symbols Sharp').then(() => {
      // FontsLibrairie.loadFont('Wingdings').then(() => {
      //   FontsLibrairie.loadFont('Wingdings2').then(() => {
      //     FontsLibrairie.loadFont('Wingdings3').then(() => {
            this.applicationService.getShapesData().then((symbols) => {
              this.symbols = symbols;
            });
      //     })
      //   });
      // });
    // });
  }

  /**
	 * Set layer
	 */
  protected setLayer(): void {
    if (this._layerData && this._layerData.type == LayerData.LINE_SHAPE) {
      this._currentSize = this.layerData.height / ContextData.MM_TO_PIXELS;
    }
  }

  /**
	 * addShapeLayer
	 */
  public addShapeLayer(symbol:any) {
    let w = NaN;
    let h = NaN;
    if (this.labelData.pixelsWidth > this.labelData.pixelsHeight) {
      h = this.labelData.height / 2;
    } else {
      w = this.labelData.width / 2;
    }

    var layerData: LayerData = new WingdingsShapeLayerData(symbol.char, symbol.fontName, TintableLayerData.DEFAULT_COLOR, 0, 0, w, h);
    this._labelData.addLayer(layerData);

    HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

    this.applicationService.currentLayerData = layerData;
  }

  /**
	 * addSquareLayer
	 */
  public addSquareLayer() {
    let w = NaN;
    let h = NaN;
    if (this.labelData.pixelsWidth > this.labelData.pixelsHeight) {
      h = this.labelData.height / 2;
    } else {
      w = this.labelData.width / 2;
    }

    var layerData: LayerData = new SquareShapeLayerData(TintableLayerData.DEFAULT_COLOR, 0, 0, w, h);
    this._labelData.addLayer(layerData);

    HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

    this.applicationService.currentLayerData = layerData;
  }

  /**
	 * addCircleLayer
	 */
  public addCircleLayer() {
    let w = NaN;
    let h = NaN;
    if (this.labelData.pixelsWidth > this.labelData.pixelsHeight) {
      h = this.labelData.height / 2;
    } else {
      w = this.labelData.width / 2;
    }

    var layerData: LayerData = new CircleShapeLayerData(TintableLayerData.DEFAULT_COLOR, 0, 0, w, h);
    this._labelData.addLayer(layerData);

    HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

    this.applicationService.currentLayerData = layerData;
  }

  /**
	 * addTriangleLayer
	 */
  public addTriangleLayer() {
    let w = NaN;
    let h = NaN;
    if (this.labelData.pixelsWidth > this.labelData.pixelsHeight) {
      h = this.labelData.height / 2;
    } else {
      w = this.labelData.width / 2;
    }

    var layerData: LayerData = new TriangleShapeLayerData(TintableLayerData.DEFAULT_COLOR, 0, 0, w, h);
    this._labelData.addLayer(layerData);

    HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

    this.applicationService.currentLayerData = layerData;
  }

  /**
	 * addLineLayer
	 */
  public addLineLayer() {
    let w = this.labelData.width;
    let h = this.currentSize;

    var layerData: LayerData = new LineShapeLayerData(TintableLayerData.DEFAULT_COLOR, 0, 0, w, h);
    this._labelData.addLayer(layerData);

    HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

    this.applicationService.currentLayerData = layerData;
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
